export const GET_TEMPLATES = "GET_TEMPLATES";
export const GET_TEMPLATE_CATEGORIES = "GET_TEMPLATE_CATEGORIES";
export const LOADING = "LOADING";
